import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { MISC_REST_CONTENT_TYPE_APPLICATION_JSON, MISC_REST_CONTENT_TYPE_MULTIPART, PRODUCTS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateProductAction = createAsyncThunk(
    'product/updateProductAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            let body = new FormData();
            const formJson = JSON.stringify(data.form);
            const formBlob = new Blob([formJson], {
                type: MISC_REST_CONTENT_TYPE_APPLICATION_JSON
            });

            body.append('picture', data.picture);
            body.append('form', formBlob);

            const response = await webClient.put(`${ PRODUCTS_PATH }/${ data.id }`, body, {
                headers: {
                    'content-type': MISC_REST_CONTENT_TYPE_MULTIPART
                }
            });
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateProductSlice = createSlice({
    name: 'updateProductSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateProductAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateProductAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateProductAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateProductState = (state) => state.product.updateProduct;
export default updateProductSlice.reducer;